window.Grid = function () {
    var el = this;

    el.items = [];
    el.cells = [];

    el.generate = function (number, gridId) {
        var images = el._parent.workData.workareas[number].images;
        var scale = (parseInt(el.format.current.width) + 2 * parseInt(el.currentProduct.company.valve)) / el.format.current.width;

        var i, cell, cells = {};
        for (i in el.cells) {
            cell = $.extend(true, {}, el.cells[i]);
            
            if (cell.grid_id === gridId) {
                cell.rotate_angle = parseInt(cell.rotate_angle);
                cell.rotate_x = parseInt(cell.rotate_x / scale) + el.valve;
                cell.rotate_y = parseInt(cell.rotate_y / scale) + el.valve;
                
                cell.border_width = parseInt(cell.border_width / scale);
                cell.border_height = parseInt(cell.border_height / scale);
                cell.border_x = parseInt(cell.border_x /scale) + el.valve;
                cell.border_y = parseInt(cell.border_y / scale) + el.valve;
                cell.border_shadow = parseInt(cell.border_shadow);
                cell.width = parseInt(cell.width / scale);
                cell.height = parseInt(cell.height / scale);
                cell.x = parseInt(cell.x / scale) + el.valve;
                cell.y = parseInt(cell.y / scale) + el.valve;
                cell.id = i;
                
                if ((cell.border_width - cell.width) % 2 === 1 || (cell.border_height - cell.height) % 2 === 1) {
                    var borderX = parseInt((cell.border_width - cell.width) / 2);
                    var borderY = parseInt((cell.border_height - cell.height) / 2);
                    var border = Math.min(borderX, borderY);
                    
                    cell.border_x = cell.x - border;
                    cell.border_y = cell.y - border;
                    cell.border_width = cell.width + 2 * border;
                    cell.border_height = cell.height + 2 * border;
                }

                if (images.hasOwnProperty(i) && images[i] !== null) {
                    var pos = {
                        x: cell.x,
                        y: cell.y,
                        width: cell.width,
                        height: cell.height
                    };
                    pos = el.upImages.setImagePosition(images[i].data_width, images[i].data_height, pos);
                    images[i].x = pos.x;
                    images[i].y = pos.y;
                    images[i].width = pos.width;
                    images[i].height = pos.height;
                }

                cells[i] = cell;
            }
        }

        el._parent.workData.workareas[number].cells = $.extend(true, {}, cells);

        el.layer.removeLayers(number);
    };

    el.show = function () {
        var templateData = {
            gridscount: []
        };

        var gridscount = {};
        var i, item, currentGrids = [];
        for (i in el.items) {
            item = el.items[i];
            if (item.format_id === el.format.current.id) {
                currentGrids.push(item.id);
            }
        }

        var gridId, cell, cells, count;
        for (i in currentGrids) {
            gridId = currentGrids[i];

            cells = [];
            for (i in el.cells) {
                cell = el.cells[i];

                if (cell.grid_id === gridId) {
                    cells.push(cell);
                }
            }

            count = cells.length;

            if (!gridscount.hasOwnProperty(count)) {
                gridscount[count] = {
                    count: count,
                    is_show: true,
                    grids: []
                };
            }

            var grid = {
                id: gridId,
                height: parseInt(180 * el.format.current.height / el.format.current.width),
                viewHeight: parseInt(800 * el.format.current.height / el.format.current.width),
                cells: cells
            };

            gridscount[count].grids.push(grid);
        }
        
        for (var i in gridscount) {
            templateData.gridscount.push(gridscount[i]);
        }

        el.dialog.show('interior_grids', templateData);
    };

    el.set = function (gridId) {
        el.generate(el.selectWorkareaId, gridId);
        el.workarea.render();
        el.history.add();
    };

    $('.js-grids-show').on('click', function () {
        el.show();
    });
};